<template>
  <!-- container -->
  <div>
      <div class="form-group p-3">
        <label for="SchoolTitle">教室名・タイトル（コース名）
                    <span class="attention">※</span>
                </label>
        <input type="text" class="form-control" id="SchoolTitle" aria-required="true" placeholder="教室名・タイトル（コース名）" v-model="event_name">
        <p class="error-msg" v-if="validation.event_name">{{ validation.event_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolTeacher">講師名（活動名）
                    <span class="attention">※</span>
                </label>
        <input type="text" class="form-control" id="SchoolTeacher" aria-required="true" placeholder="講師名（活動名）" v-model="lecturer_name">
        <p class="error-msg" v-if="validation.lecturer_name">{{ validation.lecturer_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="Day" class="col-form-label">開催日<span class="attention">※</span>
                </label>
        <textarea class="form-control" placeholder="開催日" rows="2" aria-required="true" v-model="event_date" id="Day"></textarea>
        <p class="error-msg" v-if="validation.event_date">{{ validation.event_date }}</p>
      </div>
      <div class="form-group p-3">
        <label for="Event-date-public-input" class="col-form-label">開催日(一覧表示用)
          <span class="attention">※</span>
        </label>
        <input v-if="this.event_date_public" class="form-control" id="Event-date-public-input" aria-required="true" placeholder="1/1, 1/2, 1/3" v-model="event_date_public">
        <div v-if="!this.event_date_public">
          <div v-for="(val, key) in endDate" class="" style="margin-bottom: 10px;">
            <el-date-picker
              v-model="val.date"
              type="date"
              placeholder="選択してください"
              id="Event-date-public-input"
              format="yyyy/MM/dd"
              v-bind:clearable="false"
              v-bind:editable="false"
            />
          </div>
        </div>
        <p v-if="!this.event_date_public" class="font-weight-bold">{{ eventEndDate }}</p>
        <p class="error-msg" v-if="validation.event_date_public">{{ validation.event_date_public }}</p>
      </div>
      <div v-if="this.event_date_public" class="form-group p-3">
        <label for="School-dateEnd-input" class="col-form-label">掲載終了日</label>
        <input class="form-control" type="text" value="" id="School-dateEnd-input" aria-required="true" placeholder="2017/01/01" v-model="end_date">
        <p class="error-msg" v-if="validation.end_date">{{ validation.end_date }}</p>
      </div>
      <div class="form-group p-3">
        <p for="SchoolPlace">開催場所・住所<span class="attention">※</span></p>
        <label for="SchoolPlace1">郵便番号</label>
        <input type="text" class="form-control mb-3" id="SchoolPlace1" aria-required="true" placeholder="103-0013" v-model="zipcode">
        <p class="error-msg" v-if="validation.zipcode">{{ validation.zipcode }}</p>
        <label for="SchoolPlace2">都道府県</label>
        <select class="form-control md-3" id="SchoolPlace2" aria-required="true" v-model="prefecture">
          <option value="">選択して下さい</option>
          <option>北海道</option>
          <option>青森県</option>
          <option>岩手県</option>
          <option>宮城県</option>
          <option>秋田県</option>
          <option>山形県</option>
          <option>福島県</option>
          <option>茨城県</option>
          <option>栃木県</option>
          <option>群馬県</option>
          <option>埼玉県</option>
          <option>千葉県</option>
          <option>東京都</option>
          <option>神奈川県</option>
          <option>山梨県</option>
          <option>新潟県</option>
          <option>富山県</option>
          <option>石川県</option>
          <option>福井県</option>
          <option>長野県</option>
          <option>岐阜県</option>
          <option>静岡県</option>
          <option>愛知県</option>
          <option>三重県</option>
          <option>滋賀県</option>
          <option>京都府</option>
          <option>大阪府</option>
          <option>兵庫県</option>
          <option>奈良県</option>
          <option>和歌山県</option>
          <option>鳥取県</option>
          <option>島根県</option>
          <option>岡山県</option>
          <option>広島県</option>
          <option>山口県</option>
          <option>徳島県</option>
          <option>香川県</option>
          <option>愛媛県</option>
          <option>高知県</option>
          <option>福岡県</option>
          <option>佐賀県</option>
          <option>長崎県</option>
          <option>熊本県</option>
          <option>大分県</option>
          <option>宮崎県</option>
          <option>鹿児島県</option>
          <option>沖縄県</option>
        </select>
        <p class="error-msg" v-if="validation.prefecture">{{ validation.prefecture }}</p>
        <label for="Place3">市区郡町村</label>
        <input type="text" class="form-control mb-3" id="Place3" aria-required="true" placeholder="中央区" v-model="city">
        <p class="error-msg" v-if="validation.city">{{ validation.city }}</p>
        <label for="Place4">町・番地</label>
        <input type="text" class="form-control mb-3" id="Place4" aria-required="true" placeholder="日本橋人形町2-4-9" v-model="address1">
        <p class="error-msg" v-if="validation.address1">{{ validation.address1 }}</p>
        <label for="Place5">アパート・マンション・ビル名</label>
        <input type="text" class="form-control mb-3" id="Place5" placeholder="双葉ビル802" v-model="address2">
        <p class="error-msg" v-if="validation.address2">{{ validation.address2 }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolTel">問い合わせ先電話番号</label>
        <input type="tel" class="form-control" id="SchoolTel" placeholder="03-623-0260" v-model="tel">
        <p class="error-msg" v-if="validation.tel">{{ validation.tel }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolMail">問い合わせ先メールアドレス
                    <span class="attention">※</span>
                </label>
        <input type="mail" class="form-control" id="SchoolMail" aria-required="true" placeholder="info@ohirune.com" v-model="email">
        <p class="error-msg" v-if="validation.email">{{ validation.email }}</p>
      </div>
      <div class="form-group p-3">
        <label for="School">会場名</label>
        <input type="text" class="form-control" id="School" placeholder="会場名" v-model="venue_name">
        <p class="error-msg" v-if="validation.venue_name">{{ validation.venue_name }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolURL">会場ホームページ（アクセス方法）</label>
        <input type="url" class="form-control" id="SchoolURL" placeholder="http://ohiruneart.com" v-model="homepage">
        <p class="error-msg" v-if="validation.homepage">{{ validation.homepage }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolBlog">講師ホームページ・ブログ記事URL</label>
        <input type="url" class="form-control" id="SchoolBlog" placeholder="http://ohiruneart.com" v-model="lecturer_url">
        <p class="error-msg" v-if="validation.lecturer_url">{{ validation.lecturer_url }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolDes">教室詳細<span class="attention">※</span></label>
        <textarea class="form-control" id="SchoolDes" placeholder="撮影会詳細" rows="6" aria-required="true" v-model="description"></textarea>
        <p class="error-msg" v-if="validation.description">{{ validation.description }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolPrice">参加費<span class="attention">※</span></label>
        <textarea class="form-control" id="SchoolPrice" placeholder="参加費" rows="2" aria-required="true" v-model="fee"></textarea>
        <p class="error-msg" v-if="validation.fee">{{ validation.fee }}</p>
      </div>
      <div class="form-group p-3">
        <label for="AppURL">申し込みURL</label>
        <input type="url" class="form-control" id="AppURL" placeholder="http://ohiruneart.com" v-model="entry_url">
        <p class="error-msg" v-if="validation.entry_url">{{ validation.entry_url }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolParking">駐車場有無</label>
        <select class="form-control" id="SchoolParking" v-model="parking">
                    <option value="">選んで下さい...</option>
                    <option>駐車場（有料）</option>
                    <option>駐車場（無料）</option>
                    <option>駐車場なし</option>
                </select>
                <p class="error-msg" v-if="validation.parking">{{ validation.parking }}</p>
      </div>
      <div class="form-group p-3">
        <label for="SchoolInputFile">画像アップロード</label>
        <image-input id="SchoolInputFile" v-for="index in imageFormCount" :key="index"
        @image-changed="imageChanged(index, $event)"
        :index="index"
        :image="images[index-1]"/>
        <small id="fileHelp" class="form-text text-muted">jpg,png のみ</small>
      </div>
      <div class="form-check mb-5 p-3">
        <label for="Schoolpublic">公開有無<span class="attention">※</span></label>
        <select class="form-control" id="Schoolpublic" aria-required="true" v-model="published">
                    <option value="">選んで下さい...</option>
                    <option>公開する</option>
                    <option>公開しない</option>
        </select>
        <p class="error-msg" v-if="validation.published">{{ validation.published }}</p>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ImageInput from 'components/lecturer/ImageInput'
import PrefectureSelector from 'components/PrefectureSelector'
import binder from 'store/event_form/binder'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'
import 'element-ui/lib/theme-default/index.css'
import lecturer from 'util/lecturer'
import util from 'util/common'

Vue.use(ElementUI, { locale })
const imageMaxCount = 2
export default {
  data () {
    return {
      endDate: [
        {date: ''}
      ]
    }
  },
  components: {
    ImageInput,
    PrefectureSelector
  },

  props: ['validation'],

  created () {
    var index = this.event_date_public_multi.indexOf(',')
    if (index !== -1) {
      // イベントからの画面切り替えで一覧表示用の開催日が複数選択されていたら先頭のものにする
      this.$store.commit('updateEventDatePublicMulti', this.event_date_public_multi.substr(0, index))
    }
    if (this.event_date_public_multi) {
      this.endDate[0].date = util.stringToDate(this.event_date_public_multi)
    }
  },
  methods: {
    imageChanged (index, file) {
      let imgs = [...this.images]
      imgs[index - 1] = file
      imgs = imgs.filter(i => i !== '')
      this.$store.commit('updateImages', imgs)
    }
  },

  computed: {
    ...binder,
    imageFormCount () {
      return Math.min(this.images.length + 1, imageMaxCount)
    },
    eventEndDate () {
      lecturer.eventEndDate(this)
      return '開催日の23:59まで掲載されます。'
    }
  }
}
</script>



// WEBPACK FOOTER //
// SchoolInput.vue?0ca05e0b